import type { RouteObject } from 'react-router-dom';
import { protectedRoutes } from './modules/protected';
import { publicRoutes } from './modules/public';

export const appRoutes: RouteObject[] = [...protectedRoutes, ...publicRoutes];
